import { ReactNode, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PageLoader from 'src/components/PageLoader';
import { ROUTES } from 'src/constants/routes';
import { useLocationSearch } from 'src/helpers/hooks/useLocationSearch';
import { useMount } from 'src/helpers/hooks/useMount';
import { shouldRedirectToCoverages } from 'src/pages/payment-msi/utils/should-redirect-to-coverages.util';
import {
  getPurchasePolicyAdditionalData,
  getPurchasePolicyInput,
} from 'src/redux/selectors/purchasePolicy';

interface RedirectToCoveragesGuardProps {
  children: ReactNode;
}

export function RedirectToCoveragesGuard({
  children,
}: RedirectToCoveragesGuardProps) {
  const [loadingStatus, setLoadingStatus] = useState<'pending' | 'resolved'>(
    'pending',
  );
  const navigate = useNavigate();
  const getUrlWithQueryParams = useLocationSearch();
  const redirectUrl = getUrlWithQueryParams(ROUTES.COVERAGES_DETAIL_PATH);

  const purchasePolicyInput = useSelector(getPurchasePolicyInput);
  const purchasePolicyAdditionalData = useSelector(
    getPurchasePolicyAdditionalData,
  );

  useMount(() => {
    const isRedirectToCoverages = shouldRedirectToCoverages(
      purchasePolicyInput,
      purchasePolicyAdditionalData,
    );

    if (isRedirectToCoverages) {
      navigate(redirectUrl, {
        replace: true,
      });

      setLoadingStatus('resolved');
      return;
    }

    setLoadingStatus('resolved');
  });

  if (loadingStatus === 'pending') {
    return <PageLoader />;
  }

  return <>{children}</>;
}
